import { analyzer } from '@/analyzer';
import { axios, baseUrlForService, blueApi, cached } from '@/axios.config';
import { generateCompanyCrossTagReportsV2 } from '@/lib/reports';
import { parseGrpcData } from '@alphauslabs/grpc-chunk-parser';

import crypto from 'crypto';

import moment from 'moment';
import Vue from 'vue';

export const state = {
  attributeOptionsLoading: false,
  activeFilter: null,
  filterAttributes: { accounts: [] },
  tagAttributes: { keys: [], keyValues: {} },
  filters: {
    data: {
      aws: [],
      gcp: [],
      azure: [],
    },
  },
  loading: false,
  reports: {},
  reportsLoading: false,
};

export const actions = {
  fetchReports({ commit }, { vendor, ...payload }) {
    const allRecords = [];
    commit('setReportLoading', true);
    parseGrpcData(
      {
        url: baseUrlForService('blue') + `cost/v1/${vendor}/costs:read`,
        method: 'POST',
        headers: {
          Authorization: blueApi.defaults.headers.common['Authorization'],
        },
        body: payload,
      },
      {
        limiter: 250,
        concatData: false,
        showDebug: false,
      },
      async data => {
        allRecords.push(...data);
        const reportData = {
          aws: generateCompanyCrossTagReportsV2('aws', allRecords),
          azure: generateCompanyCrossTagReportsV2('azure', allRecords),
          gcp: generateCompanyCrossTagReportsV2('gcp', allRecords),
        };
        commit('setReports', { data: reportData, vendor });
      },
      async finalData => {
        commit('setReportLoading', false);
        console.log('finalData length: ', finalData.length);
      },
      err => {
        commit('setReportLoading', false);
        throw err;
      }
    );
  },
  // fetchFilterAttributes({ commit, rootState }) {
  //   commit('setOptionsLoading', true);
  //   analyzer.time_event('Perform: ReportFiltersAttributesLoading');

  //   return blueApi
  //     .post(`cost/v1/aws/costattrs:read`, {
  //       groupId: rootState.companyId,
  //       accountId: '',
  //       startTime: moment()
  //         .subtract(1, 'month')
  //         .startOf('month')
  //         .format('YYYYMMDD'),
  //       endTime: moment()
  //         .endOf('month')
  //         .format('YYYYMMDD'),
  //       awsOptions: {
  //         dimensions: '',
  //       },
  //     })
  //     .then(({ data }) => {
  //       let attributesObject = {};
  //       let tagAttributesObject = {
  //         keys: [],
  //         keyValues: {},
  //       };

  //       const res = data.split('\n');
  //       res.pop();

  //       const parsedData = res.map(rec => JSON.parse(`${rec}`).result.aws);

  //       const createTagAttributes = tags => {
  //         tagAttributesObject.keys = Object.keys(tags);
  //         Object.keys(tags).map(key => {
  //           if (!tagAttributesObject.keyValues.hasOwnProperty(key))
  //             tagAttributesObject.keyValues[key] = ['None'];
  //           if (tags[key].length > 0 && !tagAttributesObject.keyValues[key].includes(tags[key]))
  //             tagAttributesObject.keyValues[key].push(tags[key]);
  //         });
  //       };

  //       parsedData.map(filterNode => {
  //         for (const [key, value] of Object.entries(filterNode)) {
  //           if (!attributesObject[key]) attributesObject[key] = ['None'];
  //           if (key === 'tags') createTagAttributes(value);
  //           else if (value.length > 0) attributesObject[key].push(value);
  //         }
  //       });
  //       commit('setFilterAttributes', attributesObject);
  //       commit('setTagAttributes', tagAttributesObject);
  //     })
  //     .finally(() => {
  //       analyzer.track('Perform: ReportFiltersAttributesLoading', { id: rootState.companyId });

  //       commit('setOptionsLoading', false);
  //     });
  // },

  async fetchFilterAttributes({ commit, rootState }) {
    commit('setOptionsLoading', true);
    analyzer.time_event('Perform: ReportFiltersAttributesLoading');

    const url = `cost/v1/aws/costattrs:read`;
    const params = {
      groupId: rootState.companyId,
      accountId: '',
      startTime: moment()
        .subtract(1, 'month')
        .startOf('month')
        .format('YYYYMMDD'),
      endTime: moment()
        .endOf('month')
        .format('YYYYMMDD'),
      awsOptions: {
        dimensions: '',
      },
    };

    // Create a hash from your parameters
    const hash = crypto.createHash('sha256');
    hash.update(JSON.stringify(params));

    // This will be the key for the cache
    const cacheKey = `${url}:${hash.digest('hex')}`;
    const attributeKey = `${cacheKey}:setFilterAttributes`;
    const tagKey = `${cacheKey}:setTagAttributes`;

    // Get data from cache
    const attributes = cached.get(attributeKey);
    if (attributes != undefined) {
      commit('setFilterAttributes', attributes);
    }

    const tagValues = cached.get(tagKey);
    if (tagValues != undefined) {
      commit('setTagAttributes', tagValues);
    }

    if (attributes != undefined && tagValues != undefined) {
      commit('setOptionsLoading', false);
      return true;
    }

    let attributesObject = {};
    let tagAttributesObject = {
      keys: [],
      keyValues: {},
    };

    let tempTagObject = {
      keys: [],
      keyValues: {},
    };

    return parseGrpcData(
      {
        url: baseUrlForService('blue') + url,
        method: 'POST',
        headers: {
          Authorization: blueApi.defaults.headers.common['Authorization'],
        },
        body: params,
      },
      {
        limiter: 250,
        concatData: false,
      },
      async data => {
        // Input data: {user:Name: ""}, {aws:autoscaling:groupName: "sample"}, {user:Name: "abc"}, {aws:autoscaling:groupName: ""}
        // Output data: {"keys":["user:Name","aws:autoscaling:groupName"],"keyValues":{"user:Name": {},"aws:autoscaling:groupName": {}}}
        // keyValues is store as SET to avoid duplicates values for each key

        const createTagAttributes = attributes => {
          for (let key in attributes) {
            if (!tempTagObject.keys.includes(key)) {
              tempTagObject.keys.push(key);
              tempTagObject.keyValues[key] = new Set(['None']);
            }
            if (attributes[key] !== '') {
              tempTagObject.keyValues[key].add(attributes[key]);
            }
          }
        };

        data.forEach(filterNode => {
          if (filterNode.aws) {
            const awsResult = filterNode.aws;
            Object.entries(awsResult).forEach(([key, value]) => {
              if (!attributesObject[key]) attributesObject[key] = ['None'];
              if (key === 'tags') createTagAttributes(value);
              else if (value.length > 0) attributesObject[key].push(value);
            });
          }
        });

        // Gab: Filter out tags with only "None" values and transfer to tagAttributesObject
        tagAttributesObject.keys = tempTagObject.keys.filter(
          key =>
            !(tempTagObject.keyValues[key].size === 1 && tempTagObject.keyValues[key].has('None'))
        );

        // Gab: Skip empty tags - only transfer tags that have actual values
        tagAttributesObject.keyValues = {};
        tagAttributesObject.keys.forEach(key => {
          tagAttributesObject.keyValues[key] = tempTagObject.keyValues[key];
        });
      },
      async finalData => {
        // Gab: For checking tags detail (uncomment for testing)
        // let emptyTagsCount = 0;
        // console.log('\nChecking tag keys and values ...');
        // console.log(`Empty Tag (tags with "None" only values):`);
        // Object.entries(tempTagObject.keyValues).forEach(([key, valueSet]) => {
        //   if (valueSet.size === 1 && valueSet.has('None')) {
        //     console.log(`- ${key}`);
        //     emptyTagsCount++;
        //   }
        // });

        // Gab: Count tags detail (uncomment for testing)
        // const tagsWithValuesCount = tagAttributesObject.keys.length;
        // console.log('\nTag Count Summary:');
        // console.log(`- Tags with values: ${tagsWithValuesCount}`);
        // console.log(`- Tags with only "None": ${emptyTagsCount}`);
        // console.log(`- Total tags processed: ${tempTagObject.keys.length}`);

        // eslint-disable-next-line no-console
        console.log('[fetchFilterAttributes] -> finalData length: ', finalData.length);
        analyzer.track('Perform: ReportFiltersAttributesLoading', { id: rootState.companyId });

        // Set data to cache
        cached.mset([
          { key: attributeKey, val: attributesObject },
          { key: tagKey, val: tagAttributesObject },
        ]);

        commit('setFilterAttributes', attributesObject);
        commit('setTagAttributes', tagAttributesObject);

        commit('setOptionsLoading', false);
      },
      err => {
        throw err;
      }
    );
  },

  fetchReportFilters({ commit }, { vendor }) {
    commit('setLoading', true);
    return blueApi
      .get(`cost/v1/${vendor}/costfilters`)
      .then(({ data }) => {
        commit('setReportFilters', { vendor, data: data.costFilters });
      })
      .catch(err => {
        throw err;
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },

  createReportFilter(_context, { vendor, ...payload }) {
    return blueApi.post(`cost/v1/${vendor}/costfilters`, payload);
  },

  editReportFilter(_context, { vendor, filterId, ...payload }) {
    return blueApi.put(`cost/v1/${vendor}/costfilters/${filterId}`, payload);
  },

  deleteFilterGroup(_context, { vendor, filterId }) {
    return blueApi.delete(`cost/v1/${vendor}/costfilters/${filterId}`);
  },
  fetchReportUsingFilter(
    _context,
    { filterId, startTime, endTime, groupByColumns, includeTags, dailyReport }
  ) {
    return blueApi
      .post(`cost/v1/aws/costfilters/${filterId}:export`, {
        startTime,
        endTime,
        includeTags,
        groupByColumns,
        ...(!dailyReport && { groupByMonth: true }),
      })
      .then(({ data }) => {
        if (data.hasOwnProperty('url') && data.url.length > 0) {
          //
          axios.get(data.url, { responseType: 'blob' }).then(response => {
            const blob = new Blob([response.data], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Report - ${new Date().toDateString()}.csv`;
            link.click();
            URL.revokeObjectURL(link.href);
          });
        } else throw new Error();
      });
  },
};

export const mutations = {
  setReportFilters(state, { data, vendor }) {
    Vue.set(state.filters.data, vendor, data);
  },

  setReportLoading(state, value) {
    Vue.set(state, 'reportsLoading', value);
  },

  setReports(state, { data, vendor }) {
    const reportData = data[vendor];
    Vue.set(state, 'reports', reportData);
  },

  addReportFilters(state, { data, vendor }) {
    Vue.set(state.filters.data, vendor, [...state.filters, data]);
  },

  setActiveFilter(state, { filterId }) {
    Vue.set(state, 'activeFilter', filterId);
  },
  setFilterAttributes(state, data) {
    for (const [key, value] of Object.entries(data)) {
      Vue.set(state.filterAttributes, key, [...new Set(value)]);
    }
  },
  setTagAttributes(state, data) {
    Vue.set(state.tagAttributes, 'keys', [...new Set(data.keys)]);
    Vue.set(state.tagAttributes, 'keyValues', data['keyValues']);
  },
  setOptionsLoading(state, value) {
    state.attributeOptionsLoading = value;
  },
  setLoading(state, data) {
    Vue.set(state, 'loading', data);
  },
};

export const getters = {
  getFiltersOptions: state => vendor => {
    return state.filters.data[vendor].map(filter => ({
      label: filter.filterName,
      value: filter.filterId,
    }));
  },
  getActiveFilter(state) {
    return state.activeFilter;
  },

  getAttributeOptions: state => attributeKey => {
    const found = state.filterAttributes[attributeKey];
    return found ? found : [];
  },
  getTagValueOptions: state => tagKey => {
    const found = state.tagAttributes.keys.includes(tagKey);
    return found ? state.tagAttributes.keyValues[tagKey] : [];
  },
  getTagNameOptions: state => {
    return state.tagAttributes.keys;
  },
  getActiveFilterData: state => ({ vendor, filterId }) => {
    const found = state.filters.data[vendor].findIndex(filter => filterId === filter.filterId);
    return found >= 0 ? state.filters.data[vendor][found] : null;
  },
  getOptionsLoading(state) {
    return state.attributeOptionsLoading;
  },
};
